window.Vue = require('vue');

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

Vue.component('formulario-cotizacion', require('../../componentes/sitio/FormularioCotizacion').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

if(document.getElementById("vue-cotizacion")){
    const cotizacion = new Vue({
        el: '#vue-cotizacion',
    });
}